module.exports = {
      id: "share-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#share",
      toString: function () {
        return this.url;
      }
    }